import { Exclude } from 'class-transformer';

export class ConveyanceBillingRuleResultDto {
    prefix: string;
    frequency: string;
    ruleCodeId: number;
    ruleCode: string;
    ruleType: string;
    ruleTypeText: string;
    amount: number;
    ruleDescription: string;
    isRequired: boolean;

    // Transient variable
    @Exclude()
    isSelected = false;
}
